import { ButtonGroup } from "@components/button";
import { LoadingErrorButton, LoadingErrorWrapper, Title } from "@components/smart/loadingError/LoadingError.styles";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const LOADING_ERROR_DELAY = 120_000;

export const LoadingError: React.FC = (): React.ReactElement => {
    const { t } = useTranslation("LoadingError");

    const handleReload = useCallback(() => {
        window.location.reload();
    }, []);

    return <LoadingErrorWrapper>
        <Title>{t("LoadingError:Title")}</Title>
        <ButtonGroup>
            <LoadingErrorButton onClick={handleReload}>
                {t("LoadingError:ReloadButton")}
            </LoadingErrorButton>
        </ButtonGroup>
    </LoadingErrorWrapper>;
};